import React, {Fragment} from 'react';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
	anchorRow: {
		textAlign: 'right',
		display: 'inline-block',
		marginBottom: 20,
		lineHeight: 1,
		verticalAlign: 'middle'
	},
	anchorText: {
		color: '#005383',
		fontWeight: 600,
	},
	poweredByText: {
		color: '#333333',
		fontSize: 14,
		letterSpacing: 0
	},
	infoIcon: {
		fill: '#005383',
		paddingLeft: 5,
		paddingRight: 10,
		width: 30,
		verticalAlign: 'middle'
	},
	tooltip: {
		fontSize: 12
	},
	tooltipBlue: {
		color: '#2b6994',
		fontWeight: 800
	}
});
const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#fff',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: '10',
    border: '1px solid #2b6994',
  },
}))(Tooltip);

const PoweredByFN = () => {
	const classes = useStyles();

	return (
		<Grid container className={classes.anchorRow}>
				<span className={classes.poweredByText}>
					Powered by FiscalNote
				</span>
				<HtmlTooltip
        			title={
          				<Fragment>
            				<Typography className={classes.tooltip}>CQ Roll Call is part of <span className={classes.tooltipBlue}>FiscalNote</span>, the #1 software solution for managing your policy issues.</Typography>
          				</Fragment>
        			} placement="top" arrow>
        			<InfoIcon className={classes.infoIcon} />
      			</HtmlTooltip>

				<a className={classes.anchorText} target="noopener" href="https://fiscalnote.com/?utm_source=rollcall&utm_medium=member-pages">LEARN MORE &gt;</a>
		</Grid>
	);
}

export default PoweredByFN;
